// WARNING:  CONFIGURATION IS DETERMINED AT RUNTIME FOR THIS APPLICATION.
// DO NOT USE THIS FILE.

// NB: Do not use dynamic configurations here. Use config.json instead!
export const environment = {
    production: false,
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/environments/environment.ts